import React, {useState, useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {useHistory} from 'react-router-dom';

import {psychApps, providerApps} from './psychApps.js';
import ConfirmDialog from './ConfirmDialog.js'

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import CardMedia from '@material-ui/core/CardMedia';

//import { Snackbar, Button } from '@material-ui/core';
//import List from '@material-ui/core/List';
//import ListItem from '@material-ui/core/ListItem';
//import ListItemText from '@material-ui/core/ListItemText';
//import Box from '@material-ui/core/Box';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import IconButton from '@material-ui/core/IconButton';
import HomeIcon from '@material-ui/icons/Home';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import PersonIcon from '@material-ui/icons/Person';
import MenuIcon from '@material-ui/icons/Menu';
import LinkIcon from '@material-ui/icons/Link';
import LinkOffIcon from '@material-ui/icons/LinkOff';

import {UserContext} from './UserContext.js'
import {auth, signInWithGoogle} from './firebase.js';

import google_button from './btn_google_signin_dark_normal_web.png';


const useStyles = makeStyles((theme) => ({
  navList: {
     flexGrow: 1,
  },
  navButtonsRight: {
    marginRight: theme.spacing(0),
  },
  navButtonsLeft: {
    marginLeft: theme.spacing(0),
  },
  navTitle: {
    flexGrow: 1,
  },
  media: {

  },
  providerItem: {
      color: "secondary"
  }
}));
                                         
export default function MainNavBar(props) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null); //Anchor element for general pop-up menu
    const [anchorLogin, setAnchorLogin] = useState(null); // Anchor element for login pop-up
    const [privacyOpen, setPrivacyOpen] = useState(false); // privacy dialog boolean
    const  history = useHistory();
    const {user}= useContext(UserContext);

    // Sign In To Google
    const googleSignIn = () => {
        //event.preventDefault();
        signInWithGoogle();
      }

    // Sign Out From Google
    const signOut = (event) => {
        event.preventDefault();
        auth.signOut();
    }

    // Manage Navigation of Log/Link Button
    function handleNavLoginClick(event) {
        setAnchorLogin(event.currentTarget);
    }

    function handleNavLoginClose() {
        setAnchorLogin(null);
    }

    // Create log in menu items depending on state of UserContext
    const loginMenuItems = user ? [<MenuItem key="name" id="name">Logged In: {user.email}</MenuItem>, <MenuItem key="signout" id="signout" onClick={signOut}>Sign Out</MenuItem>]: [<MenuItem key="loggedOut" id="loggedOut">...Logged Out</MenuItem>,<MenuItem key="login" id="login" onClick={handlePrivacyOpen}><CardMedia className={classes.media} image={google_button} component="img" alt="google sign-in" /></MenuItem>];
    
    // Manage Naviation of Menu Button
    function handleMenuClick(event) {
        setAnchorEl(event.currentTarget);
    }
    
    function handleClose(){ //Closing menu
        setAnchorEl(null);
    }

    function selectItem(event) {
        history.push(`/${event.target.id.toLowerCase()}`);
        //props.onNavClick(event.target.id);
        setAnchorEl(null); // Close menu
    }

    // Create menu list
    const menuItems = psychApps.map((app)=><MenuItem key={app.item} id={app.item} onClick={selectItem}>{app.title}</MenuItem>);
    const providerMenuItems = providerApps.map((app)=><MenuItem key={app.item} id={`provider/${app.item}`} onClick={selectItem}>{app.title}</MenuItem>);

    // Handle Privacy Dialog
    function handlePrivacyOpen() {
        setPrivacyOpen(true);
      }
    
      function handlePrivacyAgreeClose () { // If pt agrees to privacy, allow to move forward to app
        setPrivacyOpen(false);
        googleSignIn();
      }
  
      function handlePrivacyDisagreeClose () { //If pt does not agree to privacy, send back to main screen
        setPrivacyOpen(false);
      }

    return <>
        <AppBar color="inherit" position="fixed" className={classes.navList}>
            <Toolbar >
                <IconButton color="inherit" variant="subtitle1" className={classes.navButtonsLeft} onClick={handleMenuClick}><MenuIcon /></IconButton>
                <Typography variant="h6" color="inherit" className={classes.navTitle}>{props.title}</Typography>
                    <IconButton color="inherit" variant="subtitle1" className={classes.navButtonsRight} onClick={()=>history.push('/')}><HomeIcon /></IconButton>
                    <IconButton color="inherit" variant="subtitle1" className={classes.navButtonsRight} onClick={()=>history.push('/contact')}><ContactMailIcon /></IconButton>
                    <IconButton color="inherit" variant="subtitle1" className={classes.navButtonsRight} onClick={()=>history.push('/about')}><PersonIcon /></IconButton>
                    {
                        (user) ? <IconButton color="inherit" variant="subtitle1" className={classes.navButtonsRight} onClick={handleNavLoginClick}><LinkIcon /></IconButton> 
                        : <IconButton color="inherit" variant="subtitle1" className={classes.navButtonsRight} onClick={handleNavLoginClick}><LinkOffIcon /></IconButton> 
                    }
            </Toolbar>
        </AppBar>
        <Menu id="nav-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
            <MenuItem ><Typography color="secondary" id="" onClick={selectItem}>Client Tools</Typography></MenuItem> 
            {menuItems}
            <MenuItem ><Typography color="secondary" id="provider" onClick={selectItem}>Provider Tools</Typography></MenuItem>
            {providerMenuItems}
        </Menu>
        <Menu id="nav-login" anchorEl={anchorLogin} keepMounted open={Boolean(anchorLogin)} onClose={handleNavLoginClose}>
            {loginMenuItems}
        </Menu>
        <ConfirmDialog title={"Privacy Disclaimer"} description={<React.Fragment>Login via Google is only required for the <strong>log</strong> apps.  It is used to track history of results necessary for functionality. If you agree to sign in by Google, relevant data will be stored in Google Firestore Cloud. Note that this data is  subject to the same level of security as your general Google account data. By continuing, you acknowledge understanding and acceptance of the privacy disclaimer and <Link onClick={(e)=>e.preventDefault} href="/privacy-policy" target="_blank">policy.</Link></React.Fragment>} agree="Agree & Continue" disagree={"Return"} open={privacyOpen} onCloseClick={handlePrivacyDisagreeClose} onAgreeClick={handlePrivacyAgreeClose}/>
        </>;
}

/*
        <AppBar color="inherit" position="fixed">
            <Toolbar>
                <Typography variant="h6" color="inherit">{"Fantes.MD"}</Typography>
    
                <List component="nav">
                    <ListItem component="div" className={classes.navList}>
                        
                    <ListItemText inset>
                        <IconButton color="inherit" variant="subtitle1"><HomeIcon /></IconButton>
                    </ListItemText>
                    
                    <ListItemText inset>
                        <IconButton color="inherit" variant="subtitle1"><ContactMailIcon /></IconButton>
                    </ListItemText>
    
                    
                    <ListItemText inset>
                        <IconButton color="inherit" variant="subtitle1"><PersonIcon /></IconButton>
                    </ListItemText>
                    
                    </ListItem>
                
                </List>
            </Toolbar>
        </AppBar>
        </>; */